<template>
  <ux-form
    class="x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="auto"
    data-automation="bindEmail"
  >
    <ux-form-item :label="$t('HT.addUser.phone')" labelWidth="auto" prop="changePhone">
      <ux-input
        v-model.trim()="formData.changePhone"
        size="small"
        :maxlength="11"
        :placeholder="$t('HT.addUser.phone.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          changePhone: '',
          code: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.register(this)
    };
  }
};
</script>
